import type { BookTimelineLayout } from "../../../book/BookLayout";
import type { BoardModelKind } from "../kind";
import type { BoardModelDebugMeasureContext } from "../measurable";
import { applyBoardModelDebugMeasurable } from "../apply";
import { ensureBoardModelDebugLabelHost } from "../labelHost";
import {
  characterMeasurable,
  characterNameMeasurable,
  characterPortraitMeasurable,
} from "../ActiveCharacterGroup/markerMeasurables";

const MARKER_KINDS: BoardModelKind[] = [
  "Character",
  "CharacterPortrait",
  "CharacterName",
];

function measurableForFrame(
  kind: BoardModelKind,
  characterId: string,
) {
  if (kind === "CharacterPortrait") {
    return characterPortraitMeasurable(characterId);
  }
  if (kind === "CharacterName") {
    return characterNameMeasurable(characterId);
  }
  return characterMeasurable(characterId);
}

function syncExistingFrame(
  frame: HTMLElement,
  context: BoardModelDebugMeasureContext,
): void {
  const kind = frame.dataset.boardModel as BoardModelKind | undefined;
  const characterId = frame.dataset.boardId ?? "";
  if (kind === undefined || !MARKER_KINDS.includes(kind)) {
    return;
  }
  const measurable = measurableForFrame(kind, characterId);
  applyBoardModelDebugMeasurable(frame, measurable, context);
}

export function updateCharacterMarkerDebugFrames(
  labelsRoot: HTMLElement,
  layout: BookTimelineLayout,
  playheadMs: number,
  enabled: boolean,
): void {
  const world = labelsRoot.parentElement;
  const locationsRoot = labelsRoot.parentElement?.querySelector<HTMLElement>(
    ".timeline-locations",
  );
  if (world === null || locationsRoot == null) {
    return;
  }
  const frames = labelsRoot.querySelectorAll<HTMLElement>(
    "[data-board-debug-frame][data-board-model]",
  );
  const labelHost = ensureBoardModelDebugLabelHost(world);
  if (!enabled) {
    for (const frame of frames) {
      frame.style.display = "none";
    }
    for (const kind of MARKER_KINDS) {
      for (const label of labelHost.querySelectorAll<HTMLElement>(
        `[data-board-debug-label][data-board-model="${kind}"]`,
      )) {
        label.style.display = "none";
      }
    }
    return;
  }
  const context: BoardModelDebugMeasureContext = {
    world,
    labelHost,
    labelsRoot,
    locationsRoot,
    layout,
    playheadMs,
  };
  for (const frame of frames) {
    if (!MARKER_KINDS.includes(frame.dataset.boardModel as BoardModelKind)) {
      continue;
    }
    syncExistingFrame(frame, context);
  }
}
